module.exports = __webpack_public_path__ + "static/img/3areaB_8.9dbd189.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_8.png
// module id = 1180
// module chunks = 1